import ResqlyMark from '@/components/resqly/ResqlyMark';

export default function Logo({ size = 36, withText = true, className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <ResqlyMark size={size} />
      {withText && (
        <span className="font-bold tracking-tight text-slate-900">Resqly</span>
      )}
    </div>
  );
}
